/* eslint-disable @typescript-eslint/naming-convention */
import { css } from 'styled-components';
import product from '@bookingForm/themes/product';
import { SelectedOptionWrapper } from '@bookingForm/styles/form';
const accent = '#24195F';
const accentLight = '#01ACEA';
const accentAlt = '#00B3B5';
const invertedAccent = '#ffffff';
const numberInputColour = accent;
const border = '#f0f0f0';
const text = '#444';
const error = '#e11b20';
const success = '#0DB14B';
// eslint-disable-next-line max-len
const dottiesFont = 'Dotties, "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif';
const promotionTheme = {
    ...product,
    themeName: 'modal',
    formWrapper: css `
    ${SelectedOptionWrapper} {
      max-width: initial !important;
    }
  `,
};
export default promotionTheme;
